export const VIDEO_EXTENSIONS = [
  'mp4',
  'avi',
  'mov',
  'm4a',
  '3gp',
  'webm',
  'mkv',
  'amr',
  'm4v',
]
export const PICTURE_EXTENSIONS = ['jpg', 'png', 'jpeg', 'gif']
export const PDF_EXTENSIONS = ['pdf']
export const PUBNUB_TIMETOKEN_SHIFT = 10000000
export const TIMETOKEN_TIMEOUT = 1000

export const FILE_SIZE_LIMIT_NAME = '1 GB'
export const FILE_SIZE_LIMIT = 1073741824 // in bytes
export const MAX_CONCURRENT_UPLOADING_FILES = 1

// Surveys (screener)
export const SURVEY_ANSWER_TYPES = Object.freeze({
  RADIO: 'RADIO',
  CHECKBOX: 'CHECKBOX',
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA',
  NUMBER: 'NUMBER',
  OPTION: 'OPTION',
})
export const SURVEY_QUESTION_TYPES = Object.freeze({
  SINGLE_CHOICE: 'SINGLE_CHOICE',
  MULTI_CHOICE: 'MULTI_CHOICE',
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  DROPDOWN_LIST: 'DROPDOWN_LIST',
})

// Positive actions repetition days
export const REPETITION_DAYS_OPTIONS = Object.freeze({
  SUNDAY: 'SUNDAY',
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
})

// Courses
export const COURSES_VISIBILITY_STATUS_OPTIONS = Object.freeze([
  {
    value: 'DRAFT',
    text: 'Draft',
  },
  {
    value: 'ALL',
    text: 'Available in Library',
    selectText: 'Available in Library for all',
  },
  {
    value: 'PRIVATE',
    text: 'My participants only',
    selectText: 'Available to my participants only',
  },
])

export const DEFAULT_LANGUAGE = 'en'

export const AI_LENS_OPTIONS = Object.freeze([
  {
    text: 'Case Manager (ChatGPT)',
    value: 'CASE_MANAGER_OPEN_AI_GPT_5'
  },
  {
    text: 'Case Manager (Claude)',
    value: 'CASE_MANAGER_ANTHROPIC_CLAUDE_OPUS_4'
  },
  {
    text: 'Healthcare Specialist (ChatGPT)',
    value: 'HEALTHCARE_SPECIALIST_OPEN_AI_GPT_5'
  },
  {
    text: 'Healthcare Specialist (Claude)',
    value: 'HEALTHCARE_SPECIALIST_ANTHROPIC_CLAUDE_OPUS_4'
  }
])
